import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import { useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const VesselInfoAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const hideAllDateTimeField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const excludeTypes = ['CY', 'CYVC'];
        const ret = chargeTypeList.some(type => excludeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideVoyOperTmlAndServiceField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const includeTypes = ['TSS', 'GS'];
        const ret = chargeTypeList.some(type => !includeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideDischargeCSDatetimeField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const includeTypes = ['GS'];
        const ret = chargeTypeList.some(type => !includeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideEtbEtdDatetimeField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const includeTypes = ['TSS', 'COO', 'CODCOV', 'COS'];
        const ret = chargeTypeList.some(type => !includeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideETBDatetimeField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const excludeTypes = ['COO', 'COS'];
        const ret = chargeTypeList.some(type => excludeTypes.includes(type));
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])


    const onlyShowGateOutDatetime = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const includeTypes = ['RFH'];
        const ret = chargeTypeList.some(type => !includeTypes.includes(type));
        if (ret) {
            return false;
        } else {
            return true;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        onlyShowGateOutDatetime ?
            (<>
                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Gate Out Date/Time'
                            width='330px'
                            date={chargeBatchUpdate.gateOutDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"gateOutDatetime"} />

                    </div>
                </div>
            </>)
            :
            (<>
                {!hideVoyOperTmlAndServiceField && <>
                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item' style={{ width: "150px" }}>
                            <NbisCommonField
                                errorMessage={[]}
                                isReadOnly={false}
                                isShowOptional={false}
                                readOnlyValue={chargeBatchUpdate.voyOperatingTml ?? ""}
                                fieldValue={chargeBatchUpdate.voyOperatingTml}
                                fieldLabel={"Voy. Operating Tml"}
                                isSaveClicked={false}
                                fieldType={FieldType.DROPDOWN}
                                fieldKey={'voyOperatingTml'}
                                //maxLength={400}
                                options={chargeDetailState.dynamicOptions.operatingTmlDropdownOptions}
                                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                        </div>
                        <div className='im-flex-row-item' style={{ width: "150px" }}>
                            <NbisCommonField
                                errorMessage={[]}
                                isReadOnly={false}
                                isShowOptional={false}
                                readOnlyValue={chargeBatchUpdate.voyServiceCode ?? ""}
                                fieldValue={chargeBatchUpdate.voyServiceCode}
                                fieldLabel={"Voy. Service Code"}
                                isSaveClicked={false}
                                fieldType={FieldType.DROPDOWN}
                                fieldKey={'voyServiceCode'}
                                //maxLength={400}
                                options={chargeDetailState.dynamicOptions.serviceCodeOptions}
                                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                        </div>
                    </div>
                </>}

                {(!hideAllDateTimeField) && <>
                    {!hideEtbEtdDatetimeField && <>
                        {!hideETBDatetimeField &&
                            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                                <div className='im-flex-row-item'>
                                    <NbisDateTimePickerComponent
                                        label='Arr Date/Time'
                                        width='330px'
                                        date={chargeBatchUpdate.etb}
                                        onDateChange={chargeDetailVM.onDatePickerChange}
                                        fieldName={"etb"} />
                                </div>
                            </div>}
                        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                            <div className='im-flex-row-item'>
                                <NbisDateTimePickerComponent
                                    label='Dep. Date/Time'
                                    width='330px'
                                    date={chargeBatchUpdate.etd}
                                    onDateChange={chargeDetailVM.onDatePickerChange}
                                    fieldName={"etd"} />
                            </div>
                        </div></>}

                    {!hideDischargeCSDatetimeField &&
                        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                            <div className='im-flex-row-item'>
                                <NbisDateTimePickerComponent
                                    label='Discharge Date/Time'
                                    width='330px'
                                    date={chargeBatchUpdate.dischargeDatetime}
                                    onDateChange={chargeDetailVM.onDatePickerChange}
                                    fieldName={"dischargeDatetime"} />

                            </div>
                        </div>}

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='First Discharge Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.firstDischargeDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"firstDischargeDatetime"} />

                        </div>
                    </div>

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='Last Discharge Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.lastDischargeDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"lastDischargeDatetime"} />

                        </div>
                    </div>

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='Loading Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.loadingDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"loadingDatetime"} />

                        </div>
                    </div>

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='First Loading Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.firstLoadingDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"firstLoadingDatetime"} />

                        </div>
                    </div>

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='Last Loading Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.lastLoadingDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"lastLoadingDatetime"} />

                        </div>
                    </div>

                    {!hideDischargeCSDatetimeField &&
                        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                            <div className='im-flex-row-item'>
                                <NbisDateTimePickerComponent
                                    label='CS Date/Time'
                                    width='330px'
                                    date={chargeBatchUpdate.changeDatetime}
                                    onDateChange={chargeDetailVM.onDatePickerChange}
                                    fieldName={"changeDatetime"} />

                            </div>
                        </div>}

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='Gate In Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.gateInDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"gateInDatetime"} />

                        </div>
                    </div>

                    <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                        <div className='im-flex-row-item'>
                            <NbisDateTimePickerComponent
                                label='Gate Out Date/Time'
                                width='330px'
                                date={chargeBatchUpdate.gateOutDatetime}
                                onDateChange={chargeDetailVM.onDatePickerChange}
                                fieldName={"gateOutDatetime"} />

                        </div>
                    </div>
                </>}
            </>)
    )
}